import { AsnDetailLpnState } from '../../../interfaces/Asn/Asn'
import React, { Fragment, useEffect, useState } from 'react'
import { ApiResponse } from '../../../typings/ApiResponse'
import { PatchLpnState, getLpnState } from './Config/api'
import { Status } from '../../../hooks/useFetchState'
import {
  GenericOrderBy,
  GenericTable,
  TableHeaderConfigWithType,
  getNewDirection
} from '../../../components/_EOS/Table'
import { useApi } from '../../../hooks/useApi'
import { usePagination } from '../../../hooks/usePagination'
import { IconButton, Tooltip, Typography } from '@mui/material'
import { CheckCircle, WatchLater } from '@mui/icons-material'
import { LpnState } from '../../PutAway/types/enums'
import DoneIcon from '@mui/icons-material/Done'
import { State } from '../../_EOS/State'
import { SnackBar } from '../../SnackBar/Snackbar'
import { Loading } from '../../UI'
import TuneIcon from '@mui/icons-material/Tune'

interface GridElementLpnProps {
  asnId: number
}

type CustomActionsProps = {
  id: number
}

interface SnackbarState {
  open: boolean
  message: string
  status: string
}

export const generateTableHeadersGridLpnUser = () => {
  const headers: TableHeaderConfigWithType<AsnDetailLpnState>[] = [
    {
      field: 'lpn',
      fieldReplacement: 'lpn',
      title: 'Lpn',
      sortable: true
    },
    {
      field: 'lpnStateId',
      title: 'Estado',
      formater: (value) => renderIconLpnState(value)
    }
  ]

  return headers
}

const renderIconLpnState = (lpnStateId?: any) => {
  if (lpnStateId !== undefined) {
    switch (parseInt(lpnStateId, 10)) {
      case LpnState.Finished:
        return (
          <Tooltip title='Finalizado' aria-label='edit'>
            <CheckCircle style={{ color: 'green' }} />
          </Tooltip>
        )
      case LpnState.Pending:
      case LpnState.Created:
        return <WatchLater color='error' />
      case LpnState.Manage:
        return (
          <Tooltip title='Por Gestionar' aria-label='edit'>
            <TuneIcon />
          </Tooltip>
        )
    }
  }

  return ''
}

export const GridLpnState: React.FC<GridElementLpnProps> = ({ asnId }) => {
  const [stateSnack, setStateSnack] = useState<SnackbarState>({
    open: false,
    message: '',
    status: ''
  })
  const { open, message, status } = stateSnack
  const tableHeadersLpn = generateTableHeadersGridLpnUser()
  const { state, callApi } = useApi<ApiResponse<AsnDetailLpnState>>()
  const pagination = usePagination(5)
  const [orderBy, setOrderBy] = useState<GenericOrderBy<AsnDetailLpnState>>({
    field: '',
    direction: 'desc'
  })

  const [loadingButton, setLoadingButton] = useState<boolean>(false)

  const requestListLpnByAsn = (page?: number, pageSize?: number) => {
    callApi(getLpnState(asnId, page, pageSize, orderBy))
  }

  const handleSorting = ({
    field,
    direction
  }: GenericOrderBy<AsnDetailLpnState>) => {
    const auxField = field === 'id' ? 'asnId' : field
    if (auxField === orderBy.field) {
      const newDirection = getNewDirection(orderBy.direction)
      setOrderBy((_prev) => ({ field: auxField, direction: newDirection }))
      return
    }

    setOrderBy({ field, direction })
  }

  const handlePaginationChange = (page: number, pageSize: number) => {
    // If the pageSize is different, we should set page 0
    const auxPage = pagination.pageSize !== pageSize ? 0 : page
    requestListLpnByAsn(auxPage, pageSize)
    pagination.setPagination(auxPage, pageSize)
  }

  useEffect(() => {
    requestListLpnByAsn()
  }, [orderBy])

  const handleSendUpdateLpnState = (id: number) => {
    setLoadingButton(true)
    const row = state.data?.items.filter((element) => element.id === id)[0]

    if (row !== undefined) {
      apiUpdateLpn(row?.asnId, row?.lpn)
    }
  }

  const apiUpdateLpn = (asnId: number, lpn: string) => {
    PatchLpnState(asnId, lpn)
      .catch((error) =>
        console.log('Error: No se actualizo estado de Lpn: ', error.message)
      )
      .finally(() => {
        requestListLpnByAsn()
        handleSnackBar(true, `Se liberó correctamente Lpn: ${lpn}`, 'success')
        setLoadingButton(false)
      })
  }

  const MyCustomActions: React.FC<CustomActionsProps> = ({ id }) => {
    return (
      <Fragment>
        {loadingButton && <Loading />}
        {!loadingButton && (
          <Tooltip title='Liberar' aria-label='edit'>
            <IconButton
              aria-label='seeBinacle'
              onClick={() => handleSendUpdateLpnState(id)}
              style={{ verticalAlign: 'bottom' }}
            >
              <DoneIcon />
            </IconButton>
          </Tooltip>
        )}
      </Fragment>
    )
  }

  const handleSnackBar = (isOpen: boolean, message: string, status: string) => {
    setStateSnack({
      open: isOpen,
      message,
      status
    })
  }

  const handleOpen = (isOpen: boolean) => {
    setStateSnack((prevState) => ({ ...prevState, open: isOpen }))
  }

  return (
    <Fragment>
        <State state={state} loadingMessage='Cargando información'>
          {state.data?.items && state.data?.items.length > 0 && (
            <GenericTable<AsnDetailLpnState>
              headersConfig={tableHeadersLpn}
              IDKey={'id'}
              customActionComponent={MyCustomActions}
              data={state.data?.items}
              pagination={{
                totalItem: state.data?.totalItems || 0,
                page: pagination.page,
                pageSize: pagination.pageSize
              }}
              onPaginationChange={handlePaginationChange}
              isLoading={state.status === Status.Loading}
              onSortChange={handleSorting}
              orderField={orderBy}
            />
          )}
          {state.data?.items && state.data?.items.length === 0 && (
            <Typography>
              No se encuentran Lpn(s) en estado Finalizadas sin completar...
            </Typography>
          )}
        </State>
      <SnackBar
        open={open}
        setOpen={handleOpen}
        message={message}
        status={status}
      />
    </Fragment>
  )
}
